var _circle, _circle2, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#39BAB5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9517_83312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 18,
    height: 18,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9517_83312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.75C8.2875 16.75 8.10925 16.678 7.96525 16.534C7.82175 16.3905 7.75 16.2125 7.75 16V12.2313C7.75 12.0188 7.82175 11.8437 7.96525 11.7062C8.10925 11.5687 8.2875 11.5 8.5 11.5C8.7125 11.5 8.89075 11.5717 9.03475 11.7152C9.17825 11.8592 9.25 12.0375 9.25 12.25V16.0187C9.25 16.2312 9.17825 16.4063 9.03475 16.5438C8.89075 16.6813 8.7125 16.75 8.5 16.75ZM13 16.75C12.7875 16.75 12.6095 16.678 12.466 16.534C12.322 16.3905 12.25 16.2125 12.25 16V12.2313C12.25 12.0188 12.322 11.8437 12.466 11.7062C12.6095 11.5687 12.7875 11.5 13 11.5C13.2125 11.5 13.3908 11.5717 13.5348 11.7152C13.6783 11.8592 13.75 12.0375 13.75 12.25V16.0187C13.75 16.2312 13.6783 16.4063 13.5348 16.5438C13.3908 16.6813 13.2125 16.75 13 16.75ZM6.23125 19.75C6.01875 19.75 5.84375 19.678 5.70625 19.534C5.56875 19.3905 5.5 19.2125 5.5 19C5.5 18.7875 5.572 18.6095 5.716 18.466C5.8595 18.322 6.0375 18.25 6.25 18.25H19.7687C19.9812 18.25 20.1563 18.322 20.2938 18.466C20.4313 18.6095 20.5 18.7875 20.5 19C20.5 19.2125 20.428 19.3905 20.284 19.534C20.1405 19.678 19.9625 19.75 19.75 19.75H6.23125ZM17.5 16.75C17.2875 16.75 17.1095 16.678 16.966 16.534C16.822 16.3905 16.75 16.2125 16.75 16V12.2313C16.75 12.0188 16.822 11.8437 16.966 11.7062C17.1095 11.5687 17.2875 11.5 17.5 11.5C17.7125 11.5 17.8905 11.5717 18.034 11.7152C18.178 11.8592 18.25 12.0375 18.25 12.25V16.0187C18.25 16.2312 18.178 16.4063 18.034 16.5438C17.8905 16.6813 17.7125 16.75 17.5 16.75ZM13.675 5.0875L19.9938 8.2375C20.1563 8.325 20.2813 8.44675 20.3688 8.60275C20.4563 8.75925 20.5 8.93125 20.5 9.11875C20.5 9.36875 20.4095 9.578 20.2285 9.7465C20.047 9.9155 19.8312 10 19.5812 10H6.4375C6.1875 10 5.96875 9.9155 5.78125 9.7465C5.59375 9.578 5.5 9.36875 5.5 9.11875C5.5 8.94375 5.54075 8.775 5.62225 8.6125C5.70325 8.45 5.83125 8.33125 6.00625 8.25625L12.325 5.0875C12.5375 4.9875 12.7625 4.9375 13 4.9375C13.2375 4.9375 13.4625 4.9875 13.675 5.0875Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.8cf07f20e1b237deeb796a2e6966ede6.svg";
export { ForwardRef as ReactComponent };